export const ImageSetTypes = ["earth", "planet", "sky", "panorama", "solarSystem", "sandbox"];
export function isAddSourceMessage(o) {
    return o.type === 'add_source' &&
        typeof o.source === 'object';
}
/** A type-guard function for [[ModifySelectabilityMessage]]. */
export function isModifySelectabilityMessage(o) {
    return o.type === 'modify_selectability' &&
        typeof o.id === 'string' &&
        typeof o.selectable === 'boolean';
}
/** A type-guard function for [[ModifyAllSelectabilityMessage]]. */
export function isModifyAllSelectabilityMessage(o) {
    return o.type === 'modify_all_selectability' &&
        typeof o.selectable === 'boolean';
}
